// 场地管理页面的 接口集合
import request from "../request.js";

// 场地新增修改 会议室服务独立后台 ---- 刘献根
export const detailAdd = function (data) {
    return request({
        url: "bmMeeting/saveOperateSite",
        method: "post",
        data
    });
};

// 场地管理-获取场地详细信息 会议室服务独立后台 ---- 刘献根
export const getOperateInfo = function (data) {
    return request({
        url: "bmMeeting/getOperateSiteInfo",
        method: "post",
        data
    });
};

// 场地管理-获取场地列表  会议室服务独立后台 ---- 刘献根
export const getOperateSiteList = function (data) {
    return request({
        url: "bmMeeting/getOperateSiteList",
        method: "post",
        data
    });
};

// 场地管理-删除场地  会议室服务独立后台 ---- 刘献根
export const deleteOperate = function (data) {
    return request({
        url: "bmMeeting/deleteSite",
        method: "post",
        data
    });
};

// 删除会议室  - 郑智慧
export const deleteMeeting = function (data) {
    return request({
        url: "bmMeeting/deleteMeeting",
        method: "post",
        data
    });
};

// 场地管理-新增会议室  会议室服务独立后台 ---- 刘献根
export const saveOrUpdateOperateMeeting = function (data) {
    return request({
        url: "/bmMeeting/saveOrUpdateOperateMeeting",
        method: "post",
        data
    });
};

// 场地管理-更新会议状态 会议室服务独立后台 ---- 郑志会
export const selectMeetingState = function (data) {
    return request({
        url: "/bmMeeting/setOperateMeetingStatus",
        method: "post",
        data
    });
};

// 会议室管理-查询分页列表 ---- 郑志会
export const getoperateMeetingList = function (data) {
    return request({
        url: "bmMeeting/getoperateMeetingList",
        method: "post",
        data
    });
};

// 会议室管理-编辑回显 ---- 郑志会
export const operMeetingEcho = function (data) {
    return request({
        url: "bmMeeting/getOperateMeetingInfo",
        method: "post",
        data
    });
};

// 获取所有场地归属单位  ---- 叶凡
export const getOperateTenantMapList = function (data) {
    return request({
        url: "bmMeeting/getOperateTenantMapList",
        method: "post",
        data
    });
};

// 会议室预约记录  - 于祥东
export const getRoomList = function (data) {
    return request({
        url: "bmMeeting/selOperateMeetingApplyPageList",
        method: "post",
        data
    });
};

// 会议室申请记录-分页列表 ---- 郑志会
export const getPageMeeting = function (data) {
    return request({
        url: "bmMeeting/selOperateMeetHistoryList",
        method: "post",
        data
    });
};

// 会议室申请记录- 记录明细 ---- 郑志会
export const getOperateMeetDetailList = function (data) {
    return request({
        url: "bmMeeting/getOperateMeetDetailList",
        method: "post",
        data
    });
};

// 场地管理-摄像头管理-添加/编辑摄像头 ---- 俞祥东
export const addOrEditMeetingCameraInfo = function (data) {
    return request({
        url: "bmMeeting/addOrEditMeetingCameraInfo",
        method: "post",
        data
    });
};

// 场地管理-摄像头管理-列表查询 ---- 朱新宇
export const selMeetingCameraInfoList = function (data) {
    return request({
        url: "bmMeeting/selMeetingCameraInfoList",
        method: "post",
        data
    });
};

// 场地管理 - 摄像头管理 - 查看-- --朱新宇
export const selMeetingCameraDetailInfo = function (data) {
    return request({
        url: "bmMeeting/selMeetingCameraDetailInfo",
        method: "post",
        data
    });
};
// 场地管理 - 摄像头管理 - 查看-- --朱新宇
export const getVideoPageOfMonitor = function (data) {
    return request({
        url: "bmMeeting/getVideoPageOfMonitor",
        method: "post",
        data
    });
};

// 场地管理 - 监控异常管理 - 分页列表-- --朱新宇
export const getErrorVideoPage = function (data) {
    return request({
        url: "/bmMeeting/getErrorVideoPage",
        method: "post",
        data
    });
};
// 场地管理 - 监控异常管理 - 重新截取-- --朱新宇
export const getVideoAgain = function (data) {
    return request({
        url: "/bmMeeting/getVideoAgain",
        method: "post",
        data
    });
};
// 场地管理 - 监控异常管理 - 监控异常详情-- --朱新宇
export const getErrorDetail = function (data) {
    return request({
        url: "/bmMeeting/getErrorDetail",
        method: "post",
        data,
		requestConfig: {
			hideLoading: true
		}
    });
};
// 场地管理 - 监控异常管理 - 获取下载的监控视频-- --朱新宇
export const getVideoDownPage = function (data) {
    return request({
        url: "/bmMeeting/getVideoDownPage",
        method: "post",
        data
    });
};
// 场地管理 - 监控异常管理 - 获取监控视频-- --朱新宇
export const getVideoPlay = function (data) {
    return request({
        url: "/bmMeeting/getVideoPlay",
        method: "post",
        data
    });
};



// 添加/编辑门禁 -- --沈洋
export const addOrUpdateMeetingDoorInfo = function (data) {
    return request({
        url: "bmMeeting/addOrUpdateMeetingDoorInfo",
        method: "post",
        data
    });
};

// 获取场地信息 -- --沈洋
export const getOperateSiteData = function (data) {
    return request({
        url: "bmMeeting/getOperateSiteData",
        method: "post",
        data
    });
};

// 查看门禁信息 -- --沈洋
export const getMeetingDoorInfo = function (data) {
    return request({
        url: "bmMeeting/getMeetingDoorInfo",
        method: "post",
        data
    });
};

// 删除门禁 -- --沈洋
export const deleteMeetingDoorInfo = function (data) {
    return request({
        url: "bmMeeting/deleteMeetingDoorInfo",
        method: "post",
        data
    });
};

// 获取进场日志 -- --沈洋
export const getEntryLog = function (data) {
    return request({
        url: "bmMeeting/getEntryLog",
        method: "post",
        data
    });
};

// 场地管理-修改监控设备状态（启用/禁用）
export const changeStatus = function (data) {
	return request({
		url: "bmMeeting/changeStatus",
		method: "post",
		data
	});
};
